export default __webpack_public_path__ + "static/media/office3.85b87354.jpg";